"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfirmPrompt = void 0;

var _Confirm = _interopRequireDefault(require("UIComponents/prompts/Confirm"));

var getConfirmPrompt = function getConfirmPrompt() {
  return _Confirm.default;
};

exports.getConfirmPrompt = getConfirmPrompt;